var React = require('react');
var ReactNative = require('react-native');

var {
  Text,
  View,
    Picker
} = ReactNative;

var ReUpButton = require('./ReUpButton');
var ReUpField = require('./ReUpField');

var ReUpPicker = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      isInError: false,
      onValueChange: function(){},
      disableBackground:false,
      textInputStyle:{},
      values:["asdf"]
    }
  },

  getInitialState : function()
  {
    return {
      isInError : this.props.isInError,
      value : 0,
      valueIndex : 0
    }
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.isInError !== 'undefined' && newProps.isInError != this.state.isInError )
    {
      this.setState({isInError:newProps.isInError})
    }
  },

  focus : function()
  {
    this._picker.togglePicker();
  },

  isInError : function()
  {
    return this.state.isInError;
  },

  setIsInError : function(isInError)
  {
    this.setState({isInError : isInError});
  },

  onSelect : function(valueIndex)
  {
  	this.setValueIndex(valueIndex, true);
  },

  setValueIndex : function(valueIndex, notify=false)
  {
  	if( valueIndex < 0 ) valueIndex = 0;
  	else if( valueIndex >= this.props.values.length ) valueIndex = this.props.values.length-1;
  	else if( valueIndex === null ) valueIndex = 0;

  	this.setState({valueIndex});
  	//this._field.setText(this.props.values[valueIndex] + (this.props.values.length > 1 ? " ▼" : ""));
    //if( notify ) this.props.onValueChange(valueIndex);
  },

  render: function()
  {
  	var thisThing = this;
  	let index = 0;
    var appManager = this.props.appManager;
    var bgColor = appManager.getColorForKey("GeneralTitleColor", .03);
    if( this.props.invertBG ) bgColor = appManager.getColorForKey("GeneralColor", 1);

    var useGeneric = false;
    var generalColor = useGeneric ? 'white' : appManager.getColorForKey("GeneralColor");
    var generalTitleColor = useGeneric ? 'black' : appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = useGeneric ? 'black' : appManager.getColorForKey("FeedCardBannerColor");
    if( bannerColor == generalColor ) bannerColor = generalTitleColor;
  	// var values = [];
  	// for( var i = 0; i < this.props.values.length; i++ ) values.push({label:this.props.values[i], value:i});

    return (
    	<View style={this.props.style}>
        <select style={{
          borderTop:'none',
          borderLeft:'none',
          borderRight:'none',
          borderBottom:'none',
          color:generalTitleColor,
          borderColor:bannerColor,
          outline:'none',
          boxShadow:'none',
          WebkitAppearance:'none',
          fontFamily:'Arial',
          fontSize:20,
          borderRadius:3,
          textAlignLast: 'center',
          padding:15,
          backgroundColor: 'white',
          margin: 0
        }} onChange={(event)=>{this.onSelect(event.target.value)}}>
        {
          this.props.values.map((value, valueIndex) =>
          {
            return <option value={valueIndex}>{value}</option>
          })
        }
        </select>
      </View>
    );
  }
});

module.exports = ReUpPicker;


// WEBPACK FOOTER //
// ./src/ReUpPicker.js